import { L, vocabulary } from '../define.js';
/** D577 slice d: food-experience. */
export const FOOD_EXPERIENCE_VOCABULARIES = [
    vocabulary('food.post_sale_kind', '@vello/food-activity-ux SUPPORT_TYPES; @vello/food-postsale PostSaleKind', {
        refund: L('Reembolso', 'Refund', 'Reembolso', 'Rimborso'),
        dispute: L('Contestação', 'Dispute', 'Disputa', 'Contestazione'),
        cancellation: L('Cancelamento', 'Cancellation', 'Cancelación', 'Annullamento'),
    }),
    vocabulary('food.rating_subject', '@vello/food-activity-ux RATING_SUBJECTS', {
        merchant: L('Loja', 'Store', 'Tienda', 'Negozio'),
        courier: L('Entregador', 'Courier', 'Repartidor', 'Corriere'),
    }),
    vocabulary('food.reorder_line_status', '@vello/food-activity-ux ReorderLineStatus', {
        ok: L('Disponível', 'Available', 'Disponible', 'Disponibile'),
        price_changed: L('Preço mudou', 'Price changed', 'El precio cambió', 'Prezzo cambiato'),
        unavailable: L('Indisponível', 'Unavailable', 'No disponible', 'Non disponibile'),
    }),
    vocabulary('food.support_reason', '@vello/food-activity-ux SUPPORT_REASONS', {
        missing_items: L('Itens faltando', 'Missing items', 'Artículos faltantes', 'Articoli mancanti'),
        wrong_order: L('Pedido errado', 'Wrong order', 'Pedido equivocado', 'Ordine sbagliato'),
        quality: L('Qualidade', 'Quality', 'Calidad', 'Qualità'),
        late: L('Atraso', 'Late', 'Retraso', 'Ritardo'),
        overcharged: L('Cobrança a mais', 'Overcharged', 'Cobro de más', 'Addebito eccessivo'),
        other: L('Outro motivo', 'Other reason', 'Otro motivo', 'Altro motivo'),
    }),
    vocabulary('food.totals_component', '@vello/food-activity-ux ReceiptComponentKind; @vello/food-checkout-ux TotalsComponent', {
        subtotal: L('Subtotal', 'Subtotal', 'Subtotal', 'Subtotale'),
        fees: L('Taxas', 'Fees', 'Tarifas', 'Costi'),
        discount: L('Desconto', 'Discount', 'Descuento', 'Sconto'),
        tax: L('Impostos', 'Taxes', 'Impuestos', 'Imposte'),
        tip: L('Gorjeta', 'Tip', 'Propina', 'Mancia'),
        total: L('Total', 'Total', 'Total', 'Totale'),
    }),
    vocabulary('food.self_delivery_status', '@vello/food-fulfillment SELF_DELIVERY_STATUSES', {
        pending: L('Pendente', 'Pending', 'Pendiente', 'In attesa'),
        out_for_delivery: L('Saiu para entrega', 'Out for delivery', 'En camino', 'In consegna'),
        delivered: L('Entregue', 'Delivered', 'Entregado', 'Consegnato'),
        failed: L('Falhou', 'Failed', 'Fallido', 'Non riuscita'),
    }),
    vocabulary('food.busy_mode', '@vello/food-fulfillment BUSY_MODES', {
        off: L('Desligado', 'Off', 'Desactivado', 'Disattivato'),
        extend_prep: L('Aumentar o tempo de preparo', 'Extend prep time', 'Aumentar el tiempo de preparación', 'Aumentare il tempo di preparazione'),
        pause_new: L('Pausar novos pedidos', 'Pause new orders', 'Pausar pedidos nuevos', 'Mettere in pausa i nuovi ordini'),
    }),
    vocabulary('food.fulfillment_sla_status', '@vello/food-fulfillment SLA_STATUSES', {
        on_time: L('No prazo', 'On time', 'A tiempo', 'Nei tempi'),
        at_risk: L('Em risco', 'At risk', 'En riesgo', 'A rischio'),
        late: L('Atrasado', 'Late', 'Retrasado', 'In ritardo'),
    }),
    vocabulary('food.handoff_mode', '@vello/food-fulfillment FULFILLMENT_MODES', {
        self_delivery: L('Entrega pela própria loja', 'Delivery by the store', 'Entrega por la propia tienda', 'Consegna del negozio stesso'),
        platform_courier: L('Entregador da plataforma', 'Platform courier', 'Repartidor de la plataforma', 'Corriere della piattaforma'),
    }),
    vocabulary('problem.food_fulfillment', '@vello/food-fulfillment CAPACITY_REFUSAL_CODES; @vello/food-discovery SERVICEABILITY_REASON_CODES', {
        at_capacity: L('A loja atingiu o limite de pedidos ao mesmo tempo.', 'The store reached its limit of simultaneous orders.', 'La tienda alcanzó su límite de pedidos simultáneos.', 'Il negozio ha raggiunto il limite di ordini simultanei.'),
        busy_paused: L('A loja pausou os novos pedidos por estar ocupada.', 'The store paused new orders because it is busy.', 'La tienda pausó los pedidos nuevos por estar ocupada.', 'Il negozio ha messo in pausa i nuovi ordini perché è occupato.'),
        OUT_OF_GEOFENCE: L('O endereço está fora da área de entrega.', 'The address is outside the delivery area.', 'La dirección está fuera del área de entrega.', 'L’indirizzo è fuori dall’area di consegna.'),
        MERCHANT_CLOSED: L('A loja está fechada.', 'The store is closed.', 'La tienda está cerrada.', 'Il negozio è chiuso.'),
        OUT_OF_RANGE: L('O endereço está longe demais da loja.', 'The address is too far from the store.', 'La dirección está demasiado lejos de la tienda.', 'L’indirizzo è troppo lontano dal negozio.'),
    }, 'message'),
];
//# sourceMappingURL=food-experience.js.map